import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { FuseqHeaders } from '../../FuseQ/fuseq.headers'
import { Observable } from 'rxjs'
import { environment } from '../../../environments/environment'
@Injectable({
  providedIn: 'root'
})
export class AwpSpeedtestApiService {
  constructor (private readonly http: HttpClient, private readonly fuseqHeaders: FuseqHeaders) { }

  Get_speedtestAWP (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/speedtestAWP/Get_speedtestAWP`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  Run_speedtest (frazionari: string[], userId?: string): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/speedtestAWP/runSpeedtest`
    return this.http.post(APIEndPoint, { frazionari, user_id: userId || null }, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  Get_runStatus (runId: string): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/speedtestAWP/getRunStatus?run_id=${encodeURIComponent(runId)}`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  Get_runResults (runId: string): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/speedtestAWP/getRunResults?run_id=${encodeURIComponent(runId)}`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  Get_runHistory (userId?: string): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/speedtestAWP/getRunHistory${userId ? `?user_id=${encodeURIComponent(userId)}` : ''}`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  Get_SpeedTestHistory (frazionario: string): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/speedtestAWP/getSpeedTestHistory/${frazionario}`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  Get_TopDownloadSpeedTestCELLULAR (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/speedtestAWP/getTopDownloadSpeedTestCELLULAR`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  Get_TopDownloadSpeedTestNRD1 (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/speedtestAWP/getTopDownloadSpeedTestNRD1`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  Get_TopDownloadSpeedTestNRD2 (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/speedtestAWP/getTopDownloadSpeedTestNRD2`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  Get_TopDownloadSpeedTestMPLS1 (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/speedtestAWP/getTopDownloadSpeedTestMPLS1`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  Get_TopDownloadSpeedTestMPLS2 (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/speedtestAWP/getTopDownloadSpeedTestMPLS2`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  Get_TopUploadSpeedTestCELLULAR (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/speedtestAWP/getTopUploadSpeedTestCELLULAR`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  Get_TopUploadSpeedTestNRD1 (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/speedtestAWP/getTopUploadSpeedTestNRD1`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  Get_TopUploadSpeedTestNRD2 (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/speedtestAWP/getTopUploadSpeedTestNRD2`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  Get_TopUploadSpeedTestMPLS1 (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/speedtestAWP/getTopUploadSpeedTestMPLS1`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  Get_TopUploadSpeedTestMPLS2 (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/speedtestAWP/getTopUploadSpeedTestMPLS2`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }
}
